export default __webpack_public_path__ + "media/images/user/content-670256c985ef960fb0b8477765baa0bf.png";